'use strict';

var jsxRuntime = require('react/jsx-runtime');

const PaperClip = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-paper_clip--disabled",
            children: [
                jsxRuntime.jsx("rect", {
                    x: "12",
                    y: "12",
                    width: "36",
                    height: "42",
                    rx: "6",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M30 4C27.7909 4 26 5.79086 26 8H19V15H41V8H34C34 5.79086 32.2091 4 30 4Z",
                    fill: "white"
                }),
                jsxRuntime.jsx("path", {
                    d: "M26 8V8.7C26.3866 8.7 26.7 8.3866 26.7 8H26ZM19 8V7.3C18.6134 7.3 18.3 7.6134 18.3 8H19ZM19 15H18.3C18.3 15.3866 18.6134 15.7 19 15.7V15ZM41 15V15.7C41.3866 15.7 41.7 15.3866 41.7 15H41ZM41 8H41.7C41.7 7.6134 41.3866 7.3 41 7.3V8ZM34 8H33.3C33.3 8.3866 33.6134 8.7 34 8.7V8ZM26.7 8C26.7 6.17746 28.1775 4.7 30 4.7V3.3C27.4043 3.3 25.3 5.40426 25.3 8H26.7ZM19 8.7H26V7.3H19V8.7ZM19.7 15V8H18.3V15H19.7ZM41 14.3H19V15.7H41V14.3ZM40.3 8V15H41.7V8H40.3ZM34 8.7H41V7.3H34V8.7ZM30 4.7C31.8225 4.7 33.3 6.17746 33.3 8H34.7C34.7 5.40426 32.5957 3.3 30 3.3V4.7Z",
                    fill: "#9E9E9E"
                }),
                jsxRuntime.jsx("path", {
                    d: "M22 23H38",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M22 29H38",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M22 35H30",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("circle", {
                    cx: "46",
                    cy: "48",
                    r: "8",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M43 47.6L45.25 50L49 46",
                    stroke: "white",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("circle", {
                    cx: "30",
                    cy: "8",
                    r: "1",
                    fill: "#9E9E9E"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-paper_clip",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("rect", {
                x: "12",
                y: "12",
                width: "36",
                height: "42",
                rx: "6",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M30 4C27.7909 4 26 5.79086 26 8H19V15H41V8H34C34 5.79086 32.2091 4 30 4Z",
                fill: "white"
            }),
            jsxRuntime.jsx("path", {
                d: "M26 8V8.7C26.3866 8.7 26.7 8.3866 26.7 8H26ZM19 8V7.3C18.6134 7.3 18.3 7.6134 18.3 8H19ZM19 15H18.3C18.3 15.3866 18.6134 15.7 19 15.7V15ZM41 15V15.7C41.3866 15.7 41.7 15.3866 41.7 15H41ZM41 8H41.7C41.7 7.6134 41.3866 7.3 41 7.3V8ZM34 8H33.3C33.3 8.3866 33.6134 8.7 34 8.7V8ZM26.7 8C26.7 6.17746 28.1775 4.7 30 4.7V3.3C27.4043 3.3 25.3 5.40426 25.3 8H26.7ZM19 8.7H26V7.3H19V8.7ZM19.7 15V8H18.3V15H19.7ZM41 14.3H19V15.7H41V14.3ZM40.3 8V15H41.7V8H40.3ZM34 8.7H41V7.3H34V8.7ZM30 4.7C31.8225 4.7 33.3 6.17746 33.3 8H34.7C34.7 5.40426 32.5957 3.3 30 3.3V4.7Z",
                fill: "#212121"
            }),
            jsxRuntime.jsx("path", {
                d: "M22 23H38",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M22 29H38",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M22 35H30",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("circle", {
                cx: "46",
                cy: "48",
                r: "8",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M43 47.6L45.25 50L49 46",
                stroke: "white",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("circle", {
                cx: "30",
                cy: "8",
                r: "1",
                fill: "#212121"
            })
        ]
    });
};

module.exports = PaperClip;
